<template>
  <div>
    <div id="optional-product-modal" class="modal bd-example-modal-lg" tabindex="-1" role="dialog" style="top: 50px">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="header">
              <h2 class="modal-title">Adicionar produto opcional:</h2>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
          </div>
          <div class="modal-body">
            <FormHelper
              :inputVar="form.subgrupo"
              :form="form"
              :options="subGrupos"
              type="select"
              label="Subgrupo"
              placeholder="Selecione o subgrupo"
              name="subgrupo"
              id="subgrupo"
            ></FormHelper>

            <label class="label">Produto</label>
            <vue-select
              id="produtos-opcionais"
              v-model="form.produto.value"
              :options="produtos"
              :select-on-tab="false"
              placeholder="Selecione o produto"
            >
              <span slot="no-options">Nenhum resultado.</span>
              <template #option="option">
                <div v-if="!carregandoProdutos" class="option-content">
                  <div class="option-image">
                    <img :src="option.Imagem" alt="option.Descricao" />
                  </div>
                  <div class="option-product">
                    <strong>{{ option.Codigo }}-{{ option.CodigoDv }}</strong>
                    <div class="option-product-description">
                      <span>{{ option.label }}</span>
                      <div v-for="(associado, index) in option.Associados" :key="index">
                        <span class="option-associado">Prod. Associado: {{ associado.Codigo }}-{{ associado.CodigoDv }} - {{ associado.label }}</span>
                      </div>
                    </div>
                    <div>
                      <span class="new-badge"> {{ option.Disponibilidade }} <i class="fa fa-check"></i></span>
                      <span class="new-badge"> {{ option.Garantia }} DE GARANTIA <i class="fa fa-check"></i></span>
                      <span v-if="option.LinkFolheto" class="folhetos_produto">
                        <a v-bind:href="option.LinkFolheto" target="_blank">Folhetos <i class="fa fa-external-link"></i></a
                      ></span>
                    </div>
                  </div>
                  <div class="option-price" style="visibility:hidden">
                    <span>R$ {{ option.ValorFormatado }}</span>
                  </div>
                </div>
                <div v-else>
                  <div class="text-center">
                    <Loader v-if="carregandoProdutos" />
                  </div>
                </div>
              </template>
            </vue-select>

            <div class="actions">
              <button type="button" class="btn btn-danger" @click="close"><i class="fa fa-close" style="margin-right: 4px"></i>Cancelar</button>

              <button type="button" class="btn btn-primary" @click="adicionarInsumo">
                <i class="fa fa-plus" style="margin-right: 4px"></i>Adicionar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#produtos-opcionais .vs__dropdown-option {
  border-left: 10px solid #fff !important;
  border-bottom: 1px solid #fff !important;
  border-top: 1px solid #fff !important;
  padding: 5px 10px 10px 10px !important;
}

#produtos-opcionais .vs__dropdown-option:hover {
  background: #fff !important;
  color: #000 !important;
  border-left: 10px solid #365db5 !important;
  border-bottom: 1px solid #365db5 !important;
  border-top: 1px solid #365db5 !important;
}

#produtos-opcionais .vs__dropdown-option--highlight {
  background: #fff !important;
  color: #000 !important;
}
</style>

<style scoped>
.option-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.option-image {
  max-width: 65px;
  max-height: 65px;
  margin-right: 15px;
  border-radius: 8px;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
}

.option-product {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  width: 580px;
  min-width: 580px;
  max-width: 580px;
  word-wrap: break-word;
  word-break: break-all;
}

.option-product-description {
  word-wrap: break-word;
  word-break: break-all;
  width: 580px;
  min-width: 580px;
  max-width: 580px;
  text-align: left;
  text-wrap: wrap;
}

.option-price {
  display: flex;
  flex-direction: column;
  width: 130px !important;
  min-width: 130px !important;
  max-width: 130px !important;
  justify-content: space-around;
  align-items: flex-end;
  font-size: 12px;
}

.option-associado {
  font-size: 11px;
}

.modal-header {
  background: #365db5;
  color: white;
}

.modal-header .header {
  display: flex;
  justify-content: space-between;
}

.modal-header .close {
  color: white;
  opacity: 1;
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  display: block;
  font-weight: 400;
  padding: 0;
  padding-left: 4px;
  text-align: left;
}

.inputs {
  margin: 10px 10px 11px;
  display: flex;
  flex-direction: column;
}

.inputs .form-group {
  margin-bottom: 2px;
}

.inputs .cep {
  display: flex;
  gap: 10px;
  align-items: center;
}

.max-width {
  width: 100%;
}

.modal-title {
  font-size: 22px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 25px;
}

.new-badge {
  font-weight: bold;
  font-size: 10px;
  color: white;
  margin-right: 15px;
  padding: 3px 15px;
  border-radius: 10px;
  background-color: #50a3d3;
}

.new-badge .fa-check {
  color: rgb(108, 245, 108);
  margin-left: 5px;
  font-size: 15px;
}

.folhetos_produto {
  background-color: transparent;
  font-size: 18px;
  margin-left: 0px;
  padding-left: 5px;
}

@media (max-width: 600px) {
  .modal-title {
    font-size: 16px;
  }

  .product-title {
    font-size: 15px;
  }
}
</style>

<script>
import axios from 'axios'
import FormHelper from '../FormHelper.vue'
import Loader from '../Loader.vue'

export default {
  name: 'OptionalProductModal',

  props: ['produto'],

  data() {
    return {
      form: {
        subgrupo: new this.$formInput(false),
        produto: new this.$formInput(false),
      },
      subGrupos: [
        // { label: 'CONECTOR', code: 'CONECTOR' },
        { label: 'CONECTOR MC4', code: 'CONECTOR MC4' },
        { label: 'ESTRUTURA', code: 'ESTRUTURA' },
        { label: 'STRING BOX', code: 'STRING BOX' },
        { label: 'CABOS', code: 'CABO SOLAR' },
        // { label: 'WALLBOX', code: 'WALLBOX CARREGADOR VEICULAR' },
      ],
      produtos: [],
      carregandoProdutos: false,
    }
  },

  components: {
    FormHelper,
    Loader,
  },

  methods: {
    adicionarInsumo() {
      if (this.form.produto && this.form.produto.value) {
        const produto = this.form.produto.value
        let novosCabos = []

        if (this.produto.Insumos.some((x) => x.Codigo == produto.Codigo)) {
          swal({
            title: 'Este produto já se encontra adicionado no gerador!',
            icon: 'warning',
          })
          return
        }

        if(produto.Tipo === 'CABO SOLAR')
        {
          const cabosDoProduto = this.produto.Insumos.filter(x => x.Tipo === 'CABO SOLAR')

          const bitolaAntiga = cabosDoProduto.map(x => {
            const match = x.Descricao.match(/(4MM|6MM)/);
            return match ? match[0] : null;
          })[0]

          const bitolaNova = produto.Descricao.match(/(4MM|6MM)/)[0]

          if(bitolaAntiga && bitolaNova && bitolaAntiga !== bitolaNova)
            novosCabos = this.produtos.filter(x => x.Descricao.replace(x.Cor, '') === produto.Descricao.replace(produto.Cor, ''))
        }

        this.$emit('addInsumo',{ insumo: produto, novosCabos })

        $('#optional-product-modal').modal('hide')
      }

      this.form.subgrupo.value = ''
      this.form.produto.value = ''
      this.produtos = []
    },

    close() {
      $('#optional-product-modal').modal('hide')
    },
  },

  watch: {
    'form.subgrupo.value': function () {
      if (this.form.subgrupo.value) {
        this.produtos = [{ label: 'Carregando...', code: '' }]
        this.carregandoProdutos = true

        axios
          .post(
            `${this.$apiUrl}Produto.svc/GetProdutoOpcionais`,
            { codigoProduto: this.produto.Codigo, subgrupo: this.form.subgrupo.value.code },
            { withCredentials: true }
          )
          .then((response) => {
            if (!response.data) {
              this.produtos = []
              return
            }
            const todosProdutos = response.data.map((x) => ({
              label: x.Descricao,
              code: x.Codigo,
              opcional: true,
              ...x,
            }))

            const codigosAssociados = todosProdutos.filter((p) => p.CodigoAssociado).map((p) => p.CodigoAssociado)

            const produtos = todosProdutos
              .filter((p) => !codigosAssociados.includes(p.Codigo) && (p.MostrarInternet || p.Tipo === 'CABO SOLAR'))
              .map((p) => {
                let associados = []

                if (codigosAssociados.includes(p.CodigoAssociado)) {
                  associados = todosProdutos.filter((f) => f.Codigo === p.CodigoAssociado)
                }

                p.Associados = associados
                return p
              })

            this.carregandoProdutos = false
            this.produtos = produtos
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>
